/**
 * Updates the content of the nearest <small> element with the attribute data-product
 * to match the value of the data-gift-card attribute from the target element.
 *
 * @param {HTMLElement} target - The target element containing the data-gift-card and data-product attributes.
 */
export const productVariantSwatchesPrices = (target) => {
  const giftCardValue = target.getAttribute('data-gift-card');
  const productId = target.getAttribute('data-product');

  const labelPrice = document.querySelector(`small[data-product="${productId}"]`);
  if (labelPrice) {
    labelPrice.textContent = giftCardValue;
  }
}


